import { render } from "./AppCheckbox.vue?vue&type=template&id=648dbe93&scoped=true&lang=pug"
import script from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=648dbe93&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648dbe93"]])

export default __exports__